<header>
  <button
    class="header__skip-link"
    dgxTestHook="header__skip-link"
    (click)="scrollToMainContent()"
    type="button"
    aria-label="Skip to the main content of this page"
  >
    Skip to content
  </button>
  @if (browserShared.showVoiceBranding() && isMobile()) {
    <span class="header__voice-branding">
      <i class="fa-light fa-waveform-lines"></i>
      <p><strong>Smart-fix</strong> Voice</p>
    </span>
  } @else {
    <a
      role="menu"
      href=""
      aria-label="Domestic & General Logo"
      class="header__logo"
      [class.header__logo--ao]="client === 'ao'"
    >
      <img role="menuitem" src="/assets/branding/{{ client }}/logo.png" alt="{{ client }} Logo" />
    </a>
  }

  <nav [class.nav-open]="navigationOpen()">
    <button (click)="navigationOpen.set(!navigationOpen())" class="mobile-nav" aria-label="Toggle navigation menu">
      <i class="fa-regular fa-bars" [class.fa-bars]="!navigationOpen()" [class.fa-close]="navigationOpen()"></i>
    </button>
    <div (click)="navigationOpen.set(false)" class="backdrop"></div>
    <ul>
      @for (nav of navigationItems; track nav.url) {
        <li>
          <a [href]="nav.url" [target]="nav.target ?? '_self'" (click)="navigationOpen.set(false)">
            {{ nav.label }}
          </a>
        </li>
      }

      <li>
        <button class="logout-btn" (click)="logout()">
          <i class="fa-regular fa-arrow-right-from-bracket"></i> Logout
        </button>
      </li>
    </ul>
  </nav>
</header>

@if (showPoweredByLogo) {
  <nav class="powered-by">
    <section>
      <p>Powered by</p>
      <img role="menuitem" src="/assets/images/domestic-and-general.png" alt="Domestic and General logo" />
    </section>
  </nav>
}
